// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

import { UseCase } from '@tls/sw91-communication/types/com.base';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isProjectNameValid } from 'utilities/validations';
import { Divider, InputFieldText } from '@tls/treact-ui';

const caseNameMap: { [key: number]: string } = {
  1: 'componentDetection',
  2: 'qualityControl',
};
export const ProjectNameInput = ({ projectName, setProjectName, isEditing, useCase }) => {
  const { t } = useTranslation();
  const [caseName, setCaseName] = React.useState<string>('');

  useEffect(() => {
    const mappedCaseName = caseNameMap[useCase];
    if (mappedCaseName) {
      setCaseName(mappedCaseName);
    }
  }, [useCase]);

  const showError = useMemo(() => {
    const isValid = isProjectNameValid(projectName);
    return !isValid && projectName.length > 0;
  }, [projectName]);

  return (
    <>
      <Divider
        headline={isEditing ? t(`project.settings.dialog.${caseName}.title`) : t('projects.create.new')}
        label=''
        className='left-divider'
      />
      <InputFieldText
        flag={showError ? 'error' : 'mandatory'}
        label={t('project.name')}
        value={projectName}
        onValueChange={setProjectName}
        helperText={showError ? t('project.settings.dialog.projectNameInvalid') : undefined}
        className='match-header'
        data-testid='project-settings-project-name-input'
      />

      {useCase === UseCase.QUALITY_CHECK && (
        <Divider headline={t('projects.create.qualityControl.calibrationSettings')} label='' className='left-divider' />
      )}
    </>
  );
};
